export default __webpack_public_path__ + "static/media/char_body_008.1b64d834.png";